import { SearchForm } from "@/components/SearchForm";
import { HERO_IMG } from "@/lib/api";
import { Benefits } from "@/components/landing/Benefits";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ExampleResult } from "@/components/landing/ExampleResult";
import { RealExamples } from "@/components/landing/RealExamples";
import { PremiumValue } from "@/components/landing/PremiumValue";
import { Reassurance } from "@/components/landing/Reassurance";
import { Faq } from "@/components/landing/Faq";
import { Check } from "lucide-react";

const PROOFS = ["3 propositions au choix", "Budget estimé train / voiture", "Paiement seulement si une escapade vous plaît"];

const Hero = () => (
  <section data-testid="hero-section" className="relative bg-[#0B131E] grain overflow-hidden">
    <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0B131E]/70 via-[#0B131E]/85 to-[#0B131E]" />
    <div id="recherche" className="relative pt-36 sm:pt-40 pb-16 sm:pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto scroll-mt-16">
      <p className="rise font-mono text-xs uppercase tracking-[0.25em] text-amber-500">Escapades locales • 1 à 3 jours</p>
      <h1 data-testid="hero-title" className="rise d1 mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.1] max-w-3xl">
        Partez près de chez vous.<br /><span className="text-amber-500 italic font-medium">Sans zigzag, sans surprise.</span>
      </h1>
      <p className="rise d2 mt-5 text-base md:text-lg text-gray-200 max-w-xl leading-relaxed">
        Trois escapades courtes, crédibles en budget et géographiquement cohérentes, composées en une minute à partir de votre ville.
      </p>
      <div className="rise d3 mt-10 max-w-5xl"><SearchForm /></div>
      <div className="rise d4 mt-5 max-w-5xl flex flex-col gap-4">
        <ul data-testid="hero-proofs" className="flex flex-wrap gap-2">
          {PROOFS.map((p) => (
            <li key={p} className="flex items-center gap-2 px-3.5 py-2 rounded-full bg-emerald-500/10 border border-emerald-400/30 text-sm font-medium text-emerald-100">
              <Check className="w-4 h-4 text-emerald-400" />{p}
            </li>
          ))}
        </ul>
        <a href="#premium" data-testid="hero-premium-link" className="text-sm text-gray-300 hover:text-amber-400 transition-colors whitespace-nowrap">
          Itinéraire complet : <span className="font-semibold text-amber-400">4,90 €</span>, sans abonnement →
        </a>
      </div>
    </div>
  </section>
);

export default function Landing() {
  return (
    <>
      <Hero />
      <Benefits />
      <HowItWorks />
      <ExampleResult />
      <RealExamples />
      <PremiumValue />
      <Reassurance />
      <Faq />
    </>
  );
}
